"use client"

import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "@/utils/utils"
import { styleDrivers } from "@/utils/componentStyle"

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(styleDrivers.avatar.root, className)}
      {...props}
    />
  )
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn(styleDrivers.avatar.image, className)}
      {...props}
    />
  )
}

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(styleDrivers.avatar.fallback, className)}
      {...props}
    />
  )
}

function UserAvatar({
  className,
  imgSrc,
  imgAlt,
  alternative,
  ...props
}: {
  className?: string;
  imgSrc?: string;
  imgAlt?: string;
  alternative?: string;
}) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(styleDrivers.avatar.root, className)}
      {...props}
    >
      {imgSrc ? (
        <AvatarImage src={imgSrc} alt={imgAlt} />
      ) : (
        <AvatarFallback>{alternative}</AvatarFallback>
      )}
    </AvatarPrimitive.Root>
  )
}

export { Avatar, AvatarImage, AvatarFallback, UserAvatar };
export default UserAvatar;
